
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Listing from '../../../../models/listing';
import ListingForm from './components/listing-form/listing-form';
import Loading from '../../../../components/loading/loading';

import ListingService from '../../../../services/listing-service';

const ListingApplication = (props) => {
  const pathParams = useParams();
  const queryParams = new URLSearchParams(useLocation().search);
  const navigate = useNavigate();
  const [ listingInfo, setListingInfo ] = useState(new Listing());
  const [ applicationId, setApplicationId ] = useState();
  const [ startPatchFlag, setStartPatchFlag ] = useState(false);
  const [ activeTabIndex, setActiveTabIndex ] = useState(null);
  const [ curInstitution, setCurInstitution ] = useState();

  const listingService = new ListingService();

  useEffect(()=>{
    setCurInstitution(queryParams.get('ic'));
    if( 'applicationId' in pathParams){
      setApplicationId(pathParams['applicationId']);
    } else {
      setActiveTabIndex(0);
    }
  },[])

  useEffect(()=>{
    const service = async (applicationId) => {
      const result = await listingService.retrieveTermSheetDetails(curInstitution, applicationId);
      const listingObj = new Listing(result);
      console.log(listingObj);
      setListingInfo(listingObj);
      setActiveTabIndex(parseInt(result['activeTabIndex']) >= 6 ? 0 : parseInt(result['activeTabIndex']));
    }
    if(applicationId){
      service(applicationId);
    }
  },[applicationId])

  useEffect(()=>{
    const service = async (applicationId) => {
      const result = await listingService.patchListingApplication(curInstitution, applicationId, activeTabIndex, listingInfo);
      if( applicationId == undefined){
        setApplicationId(result['applicationId']);
        navigate('/listing/application/'+result['applicationId']+ (curInstitution?`?ic=${curInstitution}`:''), { replace: true });
      }
    }
    if(startPatchFlag && activeTabIndex){
      service(applicationId);
    } else {
      setStartPatchFlag(true);
    }
  },[listingInfo])

  const renderApplicationForm = () => {
    if( activeTabIndex === null ){ return <Loading/> }
    return <ListingForm
              curInstitution={curInstitution}
              activeTabIndex={activeTabIndex}
              setActiveTabIndex={setActiveTabIndex}
              listingInfo={listingInfo}
              setListingInfo={setListingInfo}/>
  }

  return renderApplicationForm();
}

export default ListingApplication;

